import React, { useState } from "react";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import { useDispatch } from "react-redux";
import { addToCart } from "../../redux/amazonSlice";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const Middlesection = () => {
  const productData = [
    {
      rating: {
        rate: 4.7,
        count: 78,
      },
      _id: "64d643b949a2103db68aae5b",
      id: 2,
      title: "DW Design Series Drum Kit",
      price: 1499,
      description:
        "A high-quality drum kit with a sleek design and versatile sound.",
      category: "Musical Instruments",
      image:
        "https://m.media-amazon.com/images/I/91rfcdVv5JL._AC_UF1000,1000_QL80_.jpg",
      __v: 0,
    },
    {
      rating: {
        rate: 4.7,
        count: 320,
      },
      _id: "64d64454ba26b0b2e5efc3e3",
      id: 3,
      title: "Fender Stratocaster Electric Guitar",
      price: 1299,
      description:
        "A versatile and iconic electric guitar known for its distinct tone and design.",
      category: "Musical Instruments",
      image: "https://m.media-amazon.com/images/I/51qIgHoeMWL.jpg",
      __v: 0,
    },
    {
      rating: {
        rate: 4.9,
        count: 85,
      },
      _id: "64d64454ba26b0b2e5efc3e5",
      id: 4,
      title: "Yamaha CFX Concert Grand Piano",
      price: 64999,
      description:
        "A flagship concert grand piano with exquisite tonal clarity and projection.",
      category: "Musical Instruments",
      image:
        "https://in.yamaha.com/en/files/Image-Index_cfx_02_2000x2000_e5c8a479f134e92c11394dbe0db2a008.jpg?impolicy=resize&imwid=2000&imhei=2000",
      __v: 0,
    },
    {
      rating: {
        rate: 4.8,
        count: 158,
      },
      _id: "64d64454ba26b0b2e5efc3e7",
      id: 5,
      title: "Gibson Les Paul Standard '60s",
      price: 2199,
      description:
        "A classic electric guitar with vintage tones and timeless style.",
      category: "Musical Instruments",
      image:
        "https://www.bajaao.com/cdn/shop/files/gibson-electric-guitars-gibson-les-paul-standard-60s-electric-guitar-13897785933896_500x.jpg?v=1688265932",
      __v: 0,
    },
  ];

  const [dotActive, setDocActive] = useState(0);
  const settings = {
    dots: true,
    infinite: true,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (prev, next) => {
      setDocActive(next);
    },
    appendDots: (dots) => (
      <div
        style={{
          position: "absolute",
          top: "70%",
          left: "50%",
          transform: "translate(-50%, 0)",
          width: "210px",
        }}
      >
        <ul
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    customPaging: (i) => (
      <div
        style={
          i === dotActive
            ? {
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                background: "#131921",
                padding: "8px 0",
                cursor: "pointer",
                border: "1px solid #f3a847",
              }
            : {
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#232F3E",
                color: "white",
                padding: "8px 0",
                cursor: "pointer",
                border: "1px solid white",
              }
        }
      >
        {i + 1}
      </div>
    ),
    responsive: [
      {
        breakpoint: 500,
        settings: {
          dots: true,
          appendDots: (dots) => (
            <div
              style={{
                position: "absolute",
                top: "60%",
                left: "50%",
                transform: "translate(-50%, 0)",
                width: "150px",
              }}
            >
              <ul
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  fontSize: "12px",
                }}
              >
                {" "}
                {dots}{" "}
              </ul>
            </div>
          ),
          customPaging: (i) => (
            <div
              style={
                i === dotActive
                  ? {
                      width: "25px",
                      height: "25px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      background: "#131921",
                      padding: "8px 0",
                      cursor: "pointer",
                      border: "1px solid #f3a847",
                    }
                  : {
                      width: "25px",
                      height: "25px",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background: "#232F3E",
                      color: "white",
                      padding: "8px 0",
                      cursor: "pointer",
                      border: "1px solid white",
                    }
              }
            >
              {/* 0{i + 1} */}
            </div>
          ),
        },
      },
    ],
  };

  const dispatch = useDispatch();

  return (
    <div className="mb-4 animate-fadeIn">
      <div className="my-3 ml-5">
        <h1 className="text-center text-4xl pb-2 font-bold">BEST SELLERS</h1>
      </div>
      <div className="max-w-screen-2xl mx-auto grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-10 xl:gap-4 px-4">
        {productData.map((item) => {
          return (
            <div
              key={item.id}
              className="bg-white h-auto border-[1px] border-gray-200 py-6 z-30 hover:border-transparent shadow-none hover:shadow-testShadow duration-200 relative flex flex-col gap-4"
            >
              {" "}
              <span className="text-xs capitalize italic absolute top-2 right-2 text-gray-500">
                {item.category}
              </span>
              <div className="w-full h-auto flex items-center justify-center relative group">
                {/* ========== Product Image Start here ============== */}
                <img
                  className="w-52 h-64 object-contain"
                  src={item.image}
                  alt=""
                />
                {/* ================== Product mini drop down Start here ============ */}
                <ul className="absolute w-full h-8 -bottom-4 flex flex-col justify-center items-end gap-2 pr-2">
                  <li className="productLi">
                    <Link to={`/productDetails/${item.id}`}>
                      <span>
                        Details <ArrowCircleRightIcon />
                      </span>
                    </Link>
                  </li>
                </ul>
                {/* ================== Product mini drop down End here ============== */}
              </div>
              <div className="px-4 py-0 bg-white flex flex-col z-10">
                <div className="flex items-center justify-between">
                  <h2 className="font-titleFont tracking-wide text-lg text-amazon_blue font-medium">
                    {item.title}
                  </h2>
                  <p className="text-sm text-gray-600 font-semibold">
                    Rs.{item.price}
                  </p>
                </div>
                <button
                  onClick={() =>
                    dispatch(
                      addToCart({
                        _id: item._id,
                        id: item.id,
                        title: item.title,
                        description: item.description,
                        price: item.price,
                        category: item.category,
                        image: item.image,
                        quantity: 1,
                      })
                    )
                  }
                  className="bg-blue-950 flex items-center justify-center rounded-md px-5 py-2 text-center text-sm font-medium text-white focus:outline-none focus:ring-4 focus:ring-blue-300 hover:bg-blue-900"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="mr-2 h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                  </svg>
                  Add to cart
                </button>
              </div>
            </div>
          );
        })}
      </div>

      <div className="w-full mb-20 mt-5">
        <div className="w-full h-full relative">
          <Slider {...settings}>
            <div>
              <img
                src={
                  "https://images-eu.ssl-images-amazon.com/images/G/31/img20/MusicalInstruments/IndianMI/1500x300_indian_intruments.jpg"
                }
                alt="bannerImgOne"
                className=" w-full h-[500px]"
              />
            </div>
            <div>
              <img
                src={
                  "https://yamaha.ndcdn.in/media/wysiwyg/banner_desk_27_01.jpg"
                }
                alt="bannerImgTwo"
                className=" w-full h-[500px]"
              />
            </div>
            <div>
              <img
                src={
                  "https://api.devmusicalindia.in/assets_c/1566477243912-Digital%20piano%20banner.jpg"
                }
                className=" w-full h-[500px]"
                alt="bannerImgThree"
              />
            </div>
            <div>
              <img
                src={
                  "https://yamaha.ndcdn.in/media/wysiwyg/Guitar-Desktop-Banner18mar24.jpg"
                }
                alt="bannerImgFour"
                className="h-[500px]"
              />
            </div>
            <div>
              <img
                src={
                  "https://images-eu.ssl-images-amazon.com/images/G/31/img18/MI/Revamp/ProStore/Mi_usecase_2col_1541141700._CB481141978_.jpg"
                }
                alt="bannerImgFive"
                className=" w-full h-[500px]"
              />
            </div>
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Middlesection;
